// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const crateStack = defineModel({
  id: "crate-stack",
  batchId: "future",
  name: "Crate stack",
  tags: ["scenery","crate","stack","low-poly","age-of-mcp","future"],
  summary: "Stacked crates — general packing for trade and transport.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.26, 0.26, 0.26), color: "#a9763f", position: [-0.1, 0.13, 0.02], rotation: [0, 0.05, 0] },
      { geometry: new THREE.BoxGeometry(0.2652, 0.02, 0.0468), color: "#8a5e30", position: [-0.093503, 0.1768, 0.149838], rotation: [0, 0.05, 0] },
      { geometry: new THREE.BoxGeometry(0.2652, 0.02, 0.0468), color: "#8a5e30", position: [-0.093503, 0.0832, 0.149838], rotation: [0, 0.05, 0] },
      { geometry: new THREE.BoxGeometry(0.22, 0.22, 0.22), color: "#986838", position: [0.18, 0.11, -0.06], rotation: [0, -0.1, 0] },
      { geometry: new THREE.BoxGeometry(0.2244, 0.02, 0.0396), color: "#8a5e30", position: [0.169018, 0.1496, 0.04945], rotation: [0, -0.1, 0] },
      { geometry: new THREE.BoxGeometry(0.2244, 0.02, 0.0396), color: "#8a5e30", position: [0.169018, 0.0704, 0.04945], rotation: [0, -0.1, 0] },
      { geometry: new THREE.BoxGeometry(0.2, 0.2, 0.2), color: "#986838", position: [-0.1, 0.36, 0.02], rotation: [0, 0.2, 0] },
      { geometry: new THREE.BoxGeometry(0.204, 0.02, 0.036), color: "#8a5e30", position: [-0.080133, 0.396, 0.118007], rotation: [0, 0.2, 0] },
      { geometry: new THREE.BoxGeometry(0.204, 0.02, 0.036), color: "#8a5e30", position: [-0.080133, 0.324, 0.118007], rotation: [0, 0.2, 0] },
      { geometry: new THREE.BoxGeometry(0.12, 0.12, 0.12), color: "#a9763f", position: [0.2, 0.06, 0.16] },
    ],
  animations: [],
});
